import React from 'react';
import './Loader.css';

export interface LoaderProps {
  message?: string;
  size?: 'small' | 'medium' | 'large';
  overlay?: boolean;
}

const Loader: React.FC<LoaderProps> = ({ 
  message = 'Loading...', 
  size = 'medium',
  overlay = true 
}) => {
  const LoaderContent = () => (
    <div className={`loader loader--${size}`}>
      <div className="loader__container">
        {/* Main Casino Wheel with Cards */}
        <div className="loader__main-wheel">
          <div className="loader__wheel">
            <div className="loader__wheel-inner">
              <div className="loader__chip loader__chip--1"></div>
              <div className="loader__chip loader__chip--2"></div>
              <div className="loader__chip loader__chip--3"></div>
              <div className="loader__chip loader__chip--4"></div>
              <div className="loader__chip loader__chip--5"></div>
              <div className="loader__chip loader__chip--6"></div>
            </div>
          </div>
          
          {/* Floating Casino Cards */}
          <div className="loader__card loader__card--1">♠</div>
          <div className="loader__card loader__card--2">♥</div>
          <div className="loader__card loader__card--3">♦</div>
          <div className="loader__card loader__card--4">♣</div>
        </div>
        
        {/* Slot Machine Reels Effect */}
        <div className="loader__reels">
          <div className="loader__reel">
            <div className="loader__symbol">♠</div>
            <div className="loader__symbol">♥</div>
            <div className="loader__symbol">♦</div>
            <div className="loader__symbol">♣</div>
            <div className="loader__symbol">7</div>
          </div>
          <div className="loader__reel">
            <div className="loader__symbol">7</div>
            <div className="loader__symbol">$</div>
            <div className="loader__symbol">★</div>
            <div className="loader__symbol">7</div>
            <div className="loader__symbol">💰</div>
          </div>
          <div className="loader__reel">
            <div className="loader__symbol">♦</div>
            <div className="loader__symbol">♠</div>
            <div className="loader__symbol">♥</div>
            <div className="loader__symbol">♣</div>
            <div className="loader__symbol">🎰</div>
          </div>
        </div>
        
        {/* Loading text with animated gradient */}
        <div className="loader__text">
          <span className="loader__message">{message}</span>
          <div className="loader__dots">
            <span className="loader__dot"></span>
            <span className="loader__dot"></span>
            <span className="loader__dot"></span>
          </div>
        </div>
      </div>
    </div>
  );

  if (overlay) {
    return (
      <div className="loader-overlay">
        <LoaderContent />
      </div>
    );
  }

  return <LoaderContent />;
};

export default Loader;
